module.exports = __webpack_public_path__ + "img/027-graphic-tool.52aa8ac9.svg";